import { render, staticRenderFns } from "./ShareStoryLine.vue?vue&type=template&id=2180fe52&scoped=true"
import script from "./ShareStoryLine.vue?vue&type=script&lang=js"
export * from "./ShareStoryLine.vue?vue&type=script&lang=js"
import style0 from "./ShareStoryLine.vue?vue&type=style&index=0&id=2180fe52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180fe52",
  null
  
)

export default component.exports